<template>
  <div class="t bgw">
    <div class="shop-container">
      <router-link to="/">
        <div class="logo">
          <img :src="$store.state.config.shop_logo" alt>
        </div>
      </router-link>
      <span class="title">{{headTitle}}</span>
      <span class="tip">温馨提示：产品是否购买成功，以最终下单为准哦，请尽快结算</span>
      <div class="r">
        <div class="group" v-if="userInfo">
          <div class="item">
            <div
              class="user-nav"
              @mouseover="showUserCenter=true"
              @mouseleave="showUserCenter=false"
            >
              <span class="el-dropdown-link">
                {{userInfo&&userInfo.nickname}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-collapse-transition>
                <ul v-show="showUserCenter">
                  <li class="drop-item" v-for="(item,index) in userNavArr" :key="index">
                    <router-link :to="{path:item.route}">{{item.title}}</router-link>
                  </li>
                  <li class="drop-item" @click="exit">退出账号</li>
                </ul>
              </el-collapse-transition>
            </div>
          </div>
          <div class="line">|</div>
          <div class="item">
            <router-link to="/center/myorder">我的订单</router-link>
          </div>
        </div>
        <div class="group" v-else>
          <div class="item">
            <router-link to="login">登录</router-link>
          </div>
          <div class="line">|</div>
          <div class="item">
            <router-link to="register">注册</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "CartHead",
  props: {
    headTitle: String
  },
  data() {
    return {
      hasLogin: false,
      showUserCenter: false,
      userNavArr: [
        {
          title: "个人中心",
          route: "/center"
        },
        {
          title: "我的收藏",
          route: "/center/favourite"
        }
      ]
    };
  },
  watch: {},
  computed: {
    ...mapState({
      user: state => state.userInfo
    }),
    userInfo() {
      if (this.$storage.get("userToken")) {
        return this.user && JSON.stringify(this.user) != "{}"
          ? this.user
          : this.$storage.get("userInfo")
          ? this.$storage.get("userInfo")
          : "";
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(["getCartNumsAction"]),
    exit() {
      this.$storage.remove("userToken");
      this.$storage.remove("userInfo");
      this.getCartNumsAction(0);
      this.$router.replace("/");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";
.t {
  border-bottom: 2px solid $theme-color;
  height: 100px;
  .shop-container {
    padding-top: 30px;
    .logo {
      width: 48px;
      height: 48px;
      float: left;
      margin-right: 30px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .title {
      float: left;
      margin-top: 0px;
      font-size: 28px;
      color: #424242;
      line-height: 48px;
      margin-right: 20px;
    }
    .tip {
      float: left;
      line-height: 20px;
      margin-top: 20px;
      font-size: 12px;
      color: #757575;
    }
    .group {
      float: right;
      margin-top: 20px;
      display: flex;
      color: #757575;
      font-size: 12px;
      .item {
        height: 40px;
        line-height: 40px;
        cursor: pointer;
      }
      .line {
        height: 20px;
        line-height: 20px;
        color: #757575;
        margin-top: 10px;
        margin: 10px 10px 0;
      }
    }
  }
}
.user-nav {
  width: 100px;
  cursor: pointer;
  position: relative;
  text-align: center;
  transition: all 0.2s;
  color: #b3b3b3;
  &:hover {
    background: #fff;
    color: $theme-color;
  }
  .el-dropdown-link {
    display: block;
    width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
  }
  ul {
    position: absolute;
    top: 40px;
    left: 0;
    width: 100px;
    z-index: 9999;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .drop-item {
      width: 100px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      color: #757575;
      transition: all 0.2s;
      a {
        display: block;
      }
      &:hover {
        color: $theme-color;
        background: #f5f5f5;
      }
    }
  }
}
</style>